import { Component, computed, Input, signal } from '@angular/core';
import { NbComponentStatus } from '@nebular/theme';

@Component({
  standalone: false,
  selector: 'wr-export-format-dialog',
  templateUrl: './export-format-dialog.component.html',
  styleUrls: ['./export-format-dialog.component.scss'],
})
export class ExportFormatDialogComponent {
  @Input() header = 'Export Format wählen';
  @Input() status: NbComponentStatus = 'primary';
  @Input() exportTitle = 'export';

  readonly selectedFormat = signal<'pdf' | 'csv' | null>(null);
  readonly selectedCount = signal<'list' | 'all' | null>(null);

  readonly isSubmitDisabled = computed(
    () => this.selectedFormat() === null || this.selectedCount() === null,
  );

  selectFormat(format: 'pdf' | 'csv'): void {
    this.selectedFormat.set(format);
  }

  selectCount(count: 'list' | 'all'): void {
    this.selectedCount.set(count);
  }

  getSubmitResponse = () => ({
    format: this.selectedFormat(),
    count: this.selectedCount(),
    title: this.exportTitle,
  });

  getCancelResponse = () => null;
}
